{
  "error-message-wrapper": {
    "text": {
      "custom": "{{ message }}",
      "email": "Email invalide",
      "format": "Format incorrect ({{ correctFormat }})",
      "inRange": "{{ nameOfThisControl }} doit être compris entre {{ min }} et {{ max }}",
      "notEarlier": "{{ nameOfThisControl }} doit être postérieur à {{ nameOfAnotherControl }}",
      "min": "La valeur d'entrée ne peut être inférieure à {{ min }}",
      "max": "La valeur d'entrée ne peut pas être supérieure à {{ max }}",
      "minlength": "La valeur d'entrée doit comporter au moins {{ requiredLength }} caractères",
      "maxlength": "La valeur d'entrée doit comporter au maximum {{ requiredLength }} caractères",
      "maxNumberSms": "Le nombre maximum de {{ max }} SMS a été dépassé",
      "mustContainContent": "{{ nameOfInput }} doit contenir {{ mustContainContent }}",
      "sameValue": "Le mot de passe de confirmation n'est pas le même que le mot de passe saisi.",
      "required": "Ces informations sont nécessaires"
    }
  }
}
